export default __webpack_public_path__ + "static/media/BG.70eb8a89.png";